import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { Markdown } from '~/components/markdown/Markdown';

import { LoadingStateRoot } from './components/loading-state/LoadingState.styles';

export const WatchlistSummaryRoot = styled.div`
  ${typographyV2.bodyBase};
  border-radius: 4px 0px 4px 4px;
  background: var(--surface-default);
  height: 100%;

  ${LoadingStateRoot} {
    height: 100%;
  }

  ${Markdown.Styled.MarkdownStyles} {
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    ul {
      ${typographyV2.titleBase}
    }

    ul {
      margin: 0;
      padding: 0 0 0 1em;
    }

    p {
      margin: 0;
    }
  }
`;

export const Content = styled.div`
  ${customScrollMinimal};
  overflow-y: auto;
  padding: 16px 0 0 16px;
  max-height: 350px;
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
